import { render, staticRenderFns } from "./KpiProjects.vue?vue&type=template&id=63e56209&"
import script from "./KpiProjects.vue?vue&type=script&lang=js&"
export * from "./KpiProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports